import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import enTranslation from './locales/en/translation.json';
import thTranslation from './locales/th/translation.json';

// Get stored language preference
const storedLanguage = localStorage.getItem('i18nextLng');

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'th',
    lng: storedLanguage || 'th', // Use stored language or default to Thai
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      cookieMinutes: 1440 // 24 hours
    },
    resources: {
      en: {
        translation: enTranslation
      },
      th: {
        translation: thTranslation
      }
    },
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false // prevents issues with SSR
    }
  });

// Ensure language changes are stored in localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;